import React from 'react';
import classnames from 'classnames';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

const HiddenInput: React.FC<Props> = (props) => {
  return (
    <input
      {...props}
      className={classnames('fixed -top-full -left-full block w-0 h-0 opacity-0 m-0', props.className)}
    />
  );
};

export default HiddenInput;
